import { render, staticRenderFns } from "./ScorebySubject.vue?vue&type=template&id=4070721c&scoped=true&"
import script from "./ScorebySubject.vue?vue&type=script&lang=js&"
export * from "./ScorebySubject.vue?vue&type=script&lang=js&"
import style0 from "./ScorebySubject.vue?vue&type=style&index=0&id=4070721c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070721c",
  null
  
)

export default component.exports